<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center text-sm justify-content-between catalogo-text"
          >
            Gasto
            <router-link :to="{ name: 'Servicios' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="9">
                <CInput
                  :value.sync="$v.nombre.$model"
                  :isValid="checkIfValid('nombre')"
                  label="Nombre del gasto:"
                  placeholder="Nombre..."
                  nvalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="9" md="9" lg="9">
                <label>Pertenece a:</label>
                <v-select
                  v-model="pertenece_id"
                  class="margin-multi"
                  :options="servicios"
                  placeholder="Selecciona un gasto"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
                <!-- <CSelect
                  :value.sync="servicio"
                  horizontal
                  :options="servicios"
                  placeholder="Selecciona un concepto"
                />-->
              </CCol>
            </CRow>

            <CRow v-if="pertenece_id_value">
              <CCol sm="9">
                <label>Tipo de costo:</label>
                <v-select
                  :options="tiposCosto"
                  :loading="isLoadingPage"
                  class="margin-multi"
                  placeholder="Selecciona un tipo de costo"
                  v-model="tipo_costo"
                  :class="checkIfValid('tipo_costo')===false?'is-invalid':''"
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 50 caracteres"
                >
                  <template #footer v-if="checkIfValid('tipo_costo')===false">
                    <div class="invalid-feedback">Campo requerido</div>
                  </template>
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>

            <ExtraConfigInput
              title=""
              parametro="servicios_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />

          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Servicios' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addServicios()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Servicio"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'

export default {
  name: "EditarServicio",

  components: {
    vSelect,
    ExtraConfigInput,
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      pertenece_id: null,
      nombre: "",
      servicios: [],
      tipo_costo: null,
      tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
      isLoading: false,
      isLoadingPage: false,
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
    };
  },

  mixins: [validationMixin],
  validations: {
    nombre: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    tipo_costo: {
      required: (v,data)=>{
        return true //data.pertenece_id?.value?(v?.value||false):true
      },
    }
  },

  computed: {
    pertenece_id_value(){
      return this.pertenece_id?.value?true:false
    },
    isValidServicio() {
      return !this.$v.nombre.$invalid;
    },
    isValidTipoCosto() {
      return !this.$v?.tipo_costo.$invalid;
    }
  },

  created() {
    this.isLoadingPage = true;
    this.$store;

    const serv = [
      this.$store.dispatch("customHTTP", { schema: "servicios" }),
      this.$store.dispatch("customHTTP", {
        schema: "servicios",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    Promise.all(serv)
      .then(([servicios, item]) => {
        this.servicios = servicios.data.map(servicio => {
          return { value: servicio.id, label: servicio.payload.nombre };
        });
        this.item = item.data[0];
        this.nombre = this.item.payload.nombre;
        this.tipo_costo = this.tiposCosto.find(f=>f.value == this.item.payload.tipo_costo);
        this.pertenece_id = this.servicios.find(
          serv => serv.value == this.item.payload.pertenece_id
        );

        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
        // this.servicio = this.item.payload.pertenece_id;
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {
    addServicios() {
      this.validateServicio();

      if (this.isValidServicio && this.isValidTipoCosto) {
        this.isLoading = true;

        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });

        this.$store
          .dispatch("customActualizarHTTP", {
            schema: "servicios",
            id: this.id,
            payload: {
              nombre: this.nombre,
              tipo_costo: this.tipo_costo ? this.tipo_costo.value : '',
              pertenece_id: this.pertenece_id ? this.pertenece_id.value : 0,
              ...(this.fieldsExtraConfig.length > 0)?{extras: this.fieldsExtra}:{},
            }
          })
          .then(() => {
            // console.log(res.data);
            this.$router.push({ name: "Servicios" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field?.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateServicio() {
      this.$v.$touch();
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
